import { UsuariosProcesosService } from './../_services/usuarios-procesos.service';
import { PagaduriasCondicionesHistoricosService } from './../_services/pagadurias-condiciones-historicos.service';
import { PagaduriasCondicionesService } from './../_services/pagadurias-condiciones.service';
import { UsuarioComisionFreelanceService } from './../_services/usuario-comision-freelance.service';
import { PagaduriaCondicionesEditarComponent } from './pagaduria/pagaduria-condiciones-editar/pagaduria-condiciones-editar.component';
import { PagaduriaCondicionesListadoComponent } from './pagaduria/pagaduria-condiciones-listado/pagaduria-condiciones-listado.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AplRoutingModule } from './apl-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormSharedModule } from '../shared/form-shared.module';
import { SegmentoListadoComponent } from './segmentos/segmento-listado.component';
import { SegmentosService } from '../_services/segmentos.service';
import { SegmentoActividadesComponent } from './segmentos/segmento-actividades.component';
import { ActividadEconomicaService } from '../_services/actividad-economica.service';
import { SegmentoDetalleComponent } from './segmentos/segmento-detalle.component';
import { SegmentoProductosComponent } from './segmentos/segmento-productos.component';
import { SegmentoActividadesService } from '../_services/segmento-actividades.service';
import { SegmentoProductosService } from '../_services/segmento-productos.service';
import { ProductoService } from '../_services/producto.service';
import { NivelesListadoComponent } from './niveles/niveles-listado.component';
import { NivelesService } from '../_services/niveles.service';
import { CanalesListadoComponent } from './canales/canales-listado.component';
import { CanalService } from '../_services/canal.service';
import { CanalesDetalleComponent } from './canales/canales-detalle.component';
import { CanalesEditarComponent } from './canales/canales-editar.component';
import { CanalesProductosComponent } from './canales/canales-productos.component';
import { CanalProductoService } from '../_services/canal-producto.service';
import { CanalesRolesComponent } from './canales/canales-roles.component';
import { CanalRolService } from '../_services/canal-rol.service';
import { RolesService } from '../_services/roles.service';
import { NivelesAgregarComponent } from './niveles/niveles-agregar.component';
import { NivelRangoService } from '../_services/nivel-rango.service';
import { AliadosListadoComponent } from './aliados/aliados-listado.component';
import { DivisionPoliticaService } from '../_services/division-politica.service';
import { TipoTerceroClasificacionService } from '../_services/tipo-tercero-clasificacion.service';
import { ConstanteService } from '../_services/constante.service';
import { NivelesDetalleComponent } from './niveles/niveles-detalle.component';
import { NivelesRangoUsuarioComponent } from './niveles/niveles-rango-usuario.component';
import { ZonasListadoComponent } from './zonas/zonas-listado.component';
import { ZonaService } from '../_services/zona.service';
import { ZonaBarrioService } from '../_services/zona-barrio.service';
import { ZonasEditarComponent } from './zonas/zonas-editar.component';
import { ZonasDetalleComponent } from './zonas/zonas-detalle.component';
import { ZonasTransferenciaComponent } from './zonas/zonas-transferencia.component';
import { EstructuraFisicaService } from '../_services/estructura-fisica.service';
import { AliadosSeleccionarComponent } from './aliados/aliados-seleccionar.component';
import { DetalleTerceroModule } from '../shared/detalle-tercero/detalle-tercero.module';
import { TerceroTipoTerceroService } from '../_services/tercero-tipo-tercero.service';
import { TerceroTipoClasificacionService } from '../_services/tercero-tipo-clasificacion.service';
import { TerceroService } from '../_services/tercero.service';
import { AliadosUsuariosListadoComponent } from './aliados/aliados-usuarios-listado.component';
import { AliadoUsuarioService } from '../_services/aliado-usuario.service';
import { AliadosUsuariosDetalleComponent } from './aliados/aliados-usuarios-detalle.component';
import { AliadosUsuariosEditarComponent } from './aliados/aliados-usuarios-editar.component';
import { LocalizacionesService } from '../_services/localizaciones.service';
import { UsuariosService } from '../_services/usuarios.service';
import { BancoPreguntasListadoComponent } from './banco-preguntas/banco-preguntas-listado.component';
import { BancoPreguntasService } from '../_services/banco-preguntas.service';
import { BancoPreguntasEditarComponent } from './banco-preguntas/banco-preguntas-editar.component';
import { RespuestaService } from '../_services/respuesta.service';
import { CuestionariosListadoComponent } from './cuestionarios/cuestionarios-listado.component';
import { CuestionarioService } from '../_services/cuestionario.service';
import { LocalizacionesModule } from '../shared/localizaciones/localizaciones.module';
import { EstructuraFisicaListadoComponent } from './estructura-fisica/estructura-fisica-listado.component';
import { EstructuraFisicaAsignarEjecutivoComponent } from './estructura-fisica/estructura-fisica-asignar-ejecutivo.component';
import { AgendaListadoComponent } from './agenda/agenda-listado.component';
import { AgendasService } from '../_services/agendas.service';
import { AgendaAsignarComponent } from './agenda/agenda-asignar.component';
import { CuestionariosEditarComponent } from './cuestionarios/cuestionarios-editar.component';
import { AgendaDetalleComponent } from './agenda/agenda-detalle.component';
import { TerceroCargoService } from '../_services/tercero-cargo.service';
import { TerceroZonaService } from '../_services/tercero-zona.service';
import { EstadosListadoComponent } from './estados/estados-listado.component';
import { EstadoService } from '../_services/estado.service';
import { EstadosEditarComponent } from './estados/estados-editar.component';
import { EstadosDetalleComponent } from './estados/estados-detalle.component';
import { PerfilesRiesgoListadoComponent } from './perfiles-riesgo/perfiles-riesgo-listado.component';
import { PerfilRiesgoService } from '../_services/perfil-riesgo.service';
import { PerfilRiesgoVariacionCicloService } from '../_services/perfil-riesgo-variacion-ciclo.service';
import { PerfilRiesgoVariacionMontoService } from '../_services/perfil-riesgo-variacion-monto.service';
import { PerfilesRiesgoEditarComponent } from './perfiles-riesgo/perfiles-riesgo-editar.component';
import { AdjuntoService } from '../_services/adjunto.service';
import { PerfilesRiesgoDetalleComponent } from './perfiles-riesgo/perfiles-riesgo-detalle.component';
import { PerfilesRiesgoTasaComponent } from './perfiles-riesgo/perfiles-riesgo-tasa.component';
import { PerfilesRiesgoCicloComponent } from './perfiles-riesgo/perfiles-riesgo-ciclo.component';
import { CuestionariosPreguntaComponent } from './cuestionarios/cuestionarios-pregunta.component';
import { CuestionarioPreguntaService } from '../_services/cuestionario-pregunta.service';
import { CuestionarioPreguntaRespuestaService } from '../_services/cuestionario-pregunta-respuesta.service';
import { CuestionariosPreguntaBancoComponent } from './cuestionarios/cuestionarios-pregunta-banco.component';
import { CuestionariosDetalleComponent } from './cuestionarios/cuestionarios-detalle.component';
import { CuestionariosPreguntaRespuestaComponent } from './cuestionarios/cuestionarios-pregunta-respuesta.component';
import { BancoPreguntasDetalleComponent } from './banco-preguntas/banco-preguntas-detalle.component';
import { ProductoListadoComponent } from './producto/producto-listado.component';
import { ProductosTroncalComponent } from './productos-troncal/productos-troncal.component';
import { ProductosTroncalEditarComponent } from './productos-troncal/productos-troncal-editar.component';
import { ProductosTroncalProductosComponent } from './productos-troncal/productos-troncal-productos/productos-troncal-productos.component';
import { ProductosTroncalDetalleComponent } from './productos-troncal/productos-troncal-detalle.component';
import { ProductoEditarComponent } from './producto/producto-editar.component';
import { ProductoDestinoComponent } from './producto/destinos/producto-destino.component';
import { ProductoDestinoService } from '../_services/producto-destino.service';
import { ProductoMontoService } from '../_services/producto-monto.service';
import { ProductoMontoComponent } from './producto/montos/producto-monto.component';
import { ProductoDestinoMontoComponent } from './producto/montos-destinos/producto-destino-monto.component';
import { ProductoDestinoMontoService } from '../_services/producto-destino-monto.service';
import { ProductoRenovacionComponent } from './producto/renovaciones/producto-renovacion.component';
import { ProductoRenovacionService } from '../_services/producto-renovacion.service';
import { ProductoFrecuenciaComponent } from './producto/frecuencias/producto-frecuencia.component';
import { ProductoFrecuenciaService } from '../_services/producto-frecuencia.service';
import { ProductoReferenciaService } from '../_services/producto-referencia.service';
import { ProductoReferenciaComponent } from './producto/referencias/producto-referencia.component';
import { ProductoGarantiaComponent } from './producto/garantias/producto-garantia.component';
import { ProductoGarantiaService } from '../_services/producto-garantia.service';
import { ProductoHistorialComponent } from './producto/historial/producto-historial.component';
import { ProductoHistorialService } from '../_services/producto-historial.service';
import { EstructuraFisicaDetalleComponent } from './estructura-fisica/estructura-fisica-detalle.component';
import { PoliticasCreditoListadoComponent } from './politicas-credito/politicas-credito-listado.component';
import { PoliticasCreditoService } from '../_services/politicas-credito.service';
import { PoliticasCreditoEditarComponent } from './politicas-credito/politicas-credito-editar.component';
import { PoliticasCreditoOficinasComponent } from './politicas-credito/politicas-credito-oficinas.component';
import { PoliticasCreditoOficinaService } from '../_services/politicas-credito-oficina.service';
import { ProductoEstadoService } from '../_services/producto-estado.service';
import { ProductoEstadoAliadoComponent } from './producto/estados-aliado/producto-estado-aliado.component';
import { ProductoEstadoAliadoRelacionComponent } from './producto/estados-aliado/producto-estado-aliado-relacion.component';
import { FuncionalidadesService } from '../_services/funcionalidades.service';
import { ProductoEstadoRelacionService } from '../_services/producto-estado-relacion.service';
import { ProductoEstadoAliadoRolComponent } from './producto/estados-aliado/producto-estado-aliado-rol.component';
import { ProductoEstadoRelacionRolService } from '../_services/producto-estado-relacion-rol.service';
import { ProductoActividadAliadoListadoComponent } from './producto/actividades-aliado/producto-actividad-aliado-listado.component';
import { ProductoActividadService } from '../_services/producto-actividad.service';
import { ProductoActividadCampoService } from '../_services/producto-actividad-campo.service';
import { ProductoActividadAliadoDetalleComponent } from './producto/actividades-aliado/producto-actividad-aliado-detalle.component';
import { ProductoActividadAliadoEditarComponent } from './producto/actividades-aliado/producto-actividad-aliado-editar.component';
import { ConceptoFacturacionService } from '../_services/concepto-facturacion.service';
import { ConceptoFacturacionListadoComponent } from './conceptos-facturacion/concepto-facturacion-listado.component';
import { ConceptoFacturacionDetalleComponent } from './conceptos-facturacion/concepto-facturacion-detalle.component';
import { ConceptoFacturacionEditarComponent } from './conceptos-facturacion/concepto-facturacion-editar.component';
import { ControlService } from '../_services/control.service';
import { ControlListadoComponent } from './controles/control-listado.component';
import { ControlEditarComponent } from './controles/control-editar.component';
import { PalabraClaveService } from '../_services/palabra-clave.service';
import { PalabraClaveActividadEconomicaService } from '../_services/palabra-clave-actividad-economica.service';
import { PalabraClaveListadoComponent } from './palabras-claves/palabra-clave-listado.component';
import { PalabraClaveDetalleComponent } from './palabras-claves/palabra-clave-detalle.component';
import { PalabraClaveEditarComponent } from './palabras-claves/palabra-clave-editar.component';
import { SincronizacionListadoComponent } from './sincronizaciones/sincronizacion-listado.component';
import { SincronizacionEditarComponent } from './sincronizaciones/sincronizacion-editar.component';
import { SincronizacionService } from '../_services/sincronizacion.service';
import { ProductoMontoAliadoComponent } from './producto/montos-aliados/producto-monto-aliado.component';
import { ProductoMontoAliadoService } from '../_services/producto-monto-aliado.service';
import { ProductoDetalleComponent } from './producto/producto-detalle.component';
import { PoliticasCreditoSegmentoComponent } from './politicas-credito/politicas-credito-segmento.component';
import { PoliticasCreditoDetalleComponent } from './politicas-credito/politicas-credito-detalle.component';
import { PoliticaCreditoSegmentoService } from '../_services/politica-credito-segmento.service';
import { ProductoFrecuenciaAliadoComponent } from './producto/frecuencias-aliados/producto-frecuencia-aliado.component';
import { ProductoControlService } from '../_services/producto-control.service';
import { ProductoControlComponent } from './producto/controles/producto-control.component';
import { ProductoCuestionarioComponent } from './producto/cuestionarios/producto-cuestionario.component';
import { ProductoCuestionarioService } from '../_services/producto-cuestionario.service';
import { ProductoEstadoRelacionCausalService } from '../_services/producto-estado-relacion-causal.service';
import { EstadoRolService } from '../_services/estado-rol.service';
import { EstadosRolComponent } from './estados/estados-rol.component';
import { TipoCausalListadoComponent } from './tipo-causal/tipo-causal-listado.component';
import { TipoCausalEditarComponent } from './tipo-causal/tipo-causal-editar.component';
import { TipoCausalCausalSolicitudService } from '../_services/tipo-causal-causal-solicitud.service';
import { TipoOcupacionConfiguracionListadoComponent } from './tipo-ocupacion-configuracion/tipo-ocupacion-configuracion-listado.component';
import { TipoOcupacionConfiguracionService } from '../_services/tipo-ocupacion-configuracion.service';
import { TipoOcupacionConfiguracionEditarComponent } from './tipo-ocupacion-configuracion/tipo-ocupacion-configuracion-editar.component';
import { TipoOcupacionConfiguracionDetalleComponent } from './tipo-ocupacion-configuracion/tipo-ocupacion-configuracion-detalle.component';
import { SegmentoEditarComponent } from './segmentos/segmento-editar.component';
import { SegmentoIngresosComponent } from './segmentos/segmento-ingresos.component';
import { SegmentoIngresoService } from '../_services/segmento-ingreso.service';
import { SegmentoNivelEndeudamientoService } from '../_services/segmento-nivel-endeudamiento.service';
import { SegmentoEndeudamientoComponent } from './segmentos/segmento-endeudamiento.component';
import { SegmentoActivosComponent } from './segmentos/segmento-activos.component';
import { SegmentoActivoService } from '../_services/segmento-activo.service';
import { SegmentoEmpleadosComponent } from './segmentos/segmento-empleados.component';
import { SegmentoEmpleadoService } from '../_services/segmento-empleado.service';
import { SegmentoSectorComponent } from './segmentos/segmento-sector.component';
import { SegmentoSectorService } from '../_services/segmento-sector.service';
import { SegmentoTipoContratoService } from '../_services/segmento-tipo-contrato.service';
import { SegmentoTipoContratoComponent } from './segmentos/segmento-tipo-contrato.component';
import { ProductoAutorizacionComponent } from './producto/autorizacion/producto-autorizacion.component';
import { ProductoAutorizacionService } from '../_services/producto-autorizacion.service';
import { PlantillaService } from '../_services/plantilla.service';
import { RequisitosListadoComponent } from './requisitos/requisitos-listado.component';
import { RequisitosEditarComponent } from './requisitos/requisitos-editar.component';
import { RequisitosService } from '../_services/requisitos.service';
import { RequisitosRespaldosComponent } from './requisitos/requisitos-respaldos.component';
import { RequisitosDetalleComponent } from './requisitos/requisitos-detalle.component';
import { RequisitosRespaldosService } from '../_services/requisitos-respaldos.service';
import { CentralRiesgoIntegracionListadoComponent } from './central-riesgo/central-riesgo-integracion-listado.component';
import { CentralRiesgoIntegracionService } from '../_services/central-riesgo-integracion.service';
import { CentralRiesgoIntegracionEditarComponent } from './central-riesgo/central-riesgo-integracion-editar.component';
import { CentralRiesgoIntegracionXDiaService } from '../_services/central-riesgo-integracion-x-dia.service';
import { CentralRiesgoIntegracionDetalleComponent } from './central-riesgo/central-riesgo-integracion-detalle.component';
import { ProductoVoluntadPagoComponent } from './producto/voluntad-pago/producto-voluntad-pago.component';
import { ProductoCuestionarioVoluntadPagoService } from '../_services/producto-cuestionario-voluntad-pago.service';
import { CuentaContableService } from '../_services/cuenta-contable.service';
import { CuentaContableControlService } from '../_services/cuenta-contable-control.service';
import { CuentaContableComponent } from './cuenta-contable/cuenta-contable.component';
import { SeguroListadoComponent } from './seguro/seguro-listado.component';
import { SeguroService } from '../_services/seguro.service';
import { SeguroPlanService } from '../_services/seguro-plan.service';
import { SeguroEditarComponent } from './seguro/seguro-editar.component';
import { SeguroPlanComponent } from './seguro/seguro-plan.component';
import { SeguroDetalleComponent } from './seguro/seguro-detalle.component';
import { ProductoSeguroAnalizamosService } from '../_services/producto-seguro-analizamos.service';
import { ProductoSeguroAnalizamosComponent } from './producto/seguro/producto-seguro-analizamos.component';
import { TipoRespaldoListadoComponent } from './tipo-respaldo/tipo-respaldo-listado.component';
import { TipoRespaldoService } from '../_services/tipo-respaldo.service';
import { TipoRespaldoEditarComponent } from './tipo-respaldo/tipo-respaldo-editar.component';
import { TipoRespaldoCategoriaComponent } from './tipo-respaldo/tipo-respaldo-categoria.component';
import { TipoRespaldoCategoriaService } from '../_services/tipo-respaldo-categoria.service';
import { TipoRespaldoSubcategoriaComponent } from './tipo-respaldo/tipo-respaldo-subcategoria.component';
import { TipoRespaldoClaseComponent } from './tipo-respaldo/tipo-respaldo-clase.component';
import { TipoRespaldoSubcategoriaService } from '../_services/tipo-respaldo-subcategoria.service';
import { TipoRespaldoSubcategoriaDetalleService } from '../_services/tipo-respaldo-subcategoria-detalle.service';
import { EstructuraOficinaComponent } from './estructura-fisica/estructura-oficina/estructura-oficina.component';
import { EstructuraFisicaPecuariaService } from '../_services/estructura-fisica-pecuaria.service';
import { EstructuraFisicaAgricolaService } from '../_services/estructura-fisica-agricola.service';
import { EstructuraAgricolaService } from '../_services/estructura-agricola.service';
import { EstructuraPecuariaService } from '../_services/estructura-pecuaria.service';
import { TipoRespaldoDetalleComponent } from './tipo-respaldo/tipo-respaldo-detalle.component';
import { TipoRespaldoDetalleSubcategoriaComponent } from './tipo-respaldo/tipo-respaldo-detalle-subcategoria.component';
import { VinculacionTerceroComponent } from './vinculacion-tercero/vinculacion-tercero.component';
import { MenuVisitaComponent } from './menu-visita/menu-visita.component';
import { MenuVisitaService } from '../_services/menu-visita.service';
import { VinculacionTerceroVinculacionComponent } from './vinculacion-tercero/vinculacion-tercero-vinculacion.component';
import { MenuVisitaVinculacionService } from '../_services/menu-visita-vinculacion.service';
import { VinculacionTerceroOcupacionComponent } from './vinculacion-tercero/vinculacion-tercero-ocupacion.component';
import { MenuVisitaVinculacionOcupacionService } from '../_services/menu-visita-vinculacion-ocupacion.service';
import { ProcesoProductivoListadoComponent } from './proceso-productivo/proceso-productivo-listado.component';
import { ProcesoProductivoEditarComponent } from './proceso-productivo/proceso-productivo-editar.component';
import { ProcesoProductivoService } from '../_services/proceso-productivo.service';
import { ProcesoVariableIncidenciaService } from '../_services/proceso-variable-incidencia.service';
import { ProcesoProductivoVariableIncidenciaComponent } from './proceso-productivo/proceso-productivo-variable-incidencia.component';
import { ProcesoProductivoDetalleComponent } from './proceso-productivo/proceso-productivo-detalle.component';
import { PlagaListadoComponent } from './plaga/plaga-listado.component';
import { PlagaEditarComponent } from './plaga/plaga-editar.component';
import { PlagaProductoComercialComponent } from './plaga/plaga-producto-comercial.component';
import { PlagaProductoComponent } from './plaga/plaga-producto.component';
import { PlagaService } from '../_services/plaga.service';
import { PlagaProductoAgricolaService } from '../_services/plaga-producto-agricola.service';
import { ControlPlagaService } from '../_services/control-plaga.service';
import { ProductoAgricolaService } from '../_services/producto-agricola.service';
import { VinculacionTerceroDetalleSubmenuComponent } from './vinculacion-tercero/vinculacion-tercero-detalle-submenu.component';
import { PlagaDetalleComponent } from './plaga/plaga-detalle.component';
import { FormaDesembolsoComponent } from './forma-desembolso/forma-desembolso.component';
import { FormaDesembolsoService } from '../_services/forma-desembolso.service';
import { ProductoFormaDesembolsoService } from '../_services/producto-forma-desembolso.service';
import { ProductoFormaDesembolsoComponent } from './producto/forma-desembolso/producto-forma-desembolso.component';
import { ModalidadesDetalleComponent } from './modalidades/modalidades-detalle.component';
import { ModalidadesEditarComponent } from './modalidades/modalidades-editar.component';
import { ModalidadesListadoComponent } from './modalidades/modalidades-listado.component';
import { ModalidadService } from '../_services/modalidad.service';
import { AlertaService } from '../_services/alerta.service';
import { AlertaListadoComponent } from './alertas/alerta-listado.component';
import { AlertaEditarComponent } from './alertas/alerta-editar.component.ts/alerta-editar.component';
import { AlertaPerfilRiesgoService } from '../_services/alerta-perfil-riesgo.service';
import { AlertaEstructuraFisicaService } from '../_services/alerta-estructura-fisica.service';
import { AlertaTipoVinculacionService } from '../_services/alerta-tipo-vinculacion.service';
import { AlertaAprobacionService } from '../_services/alerta-aprobacion.service';
import { AlertaDescarteService } from '../_services/alerta-descarte.service';
import { AlertaDetalleService } from '../_services/alerta-detalle.service';
import { VinculacionEstadoFinancieroComponent } from './vinculacion-estado-financiero/vinculacion-estado-financiero.component';
import { VinculacionEstadoFinancieroService } from '../_services/vinculacion-estado-financiero.service';
import { ModalidadesAutorizacionesComponent } from './modalidades/modalidades-autorizaciones.component';
import { ModalidadAutorizacionService } from '../_services/modalidad-autorizacion.service';
import { AlertaDetalleComponent } from './alertas/alerta-detalle.component.ts/alerta-detalle.component';
import { ProductoRestriccionComponent } from './producto/restricciones/producto-restriccion.component';
import { AgrupacionService } from '../_services/agrupacion.service';
import { ProductoRestriccionBarriosComponent } from './producto/restricciones/producto-restriccion-barrios.component';
import { ProductoRestriccionOficinaService } from '../_services/producto-restriccion-oficina.service';
import { ProductoRestriccionBarrioService } from '../_services/producto-restriccion-barrio.service';
import { ModalidadesTasasComponent } from './modalidades/modalidades-tasas/modalidades-tasas.component';
import { ModalidadTasaService } from '../_services/modalidad-tasa.service';
import { ModalidadesCalificacionesComponent } from './modalidades/modalidades-calificaciones/modalidades-calificaciones.component';
import { ModalidadCalificacionService } from '../_services/modalidad-calificacion.service';
import { ProductoDesembolsoListadoComponent } from './producto/desembolso/producto-desembolso-listado.component';
import { ProductoDesembolsoService } from '../_services/producto-desembolso.service';
import { ProductoDesembolsoDetalleComponent } from './producto/desembolso/producto-desembolso-detalle.component';
import { ProductoDesembolsoEditarComponent } from './producto/desembolso/producto-desembolso-editar.component';
import { ConveniosComponent } from './convenios/convenios.component';
import { NivelesRangoTasaUsuarioComponent } from './niveles/niveles-rango-tasa-usuario.component';
import { NivelTasaService } from '../_services/nivel-tasa.service';
import { ConveniosEditarComponent } from './convenios/convenios-editar/convenios-editar.component';
import { ConveniosDetalleComponent } from './convenios/convenios-detalle/convenios-detalle.component';
import { ConvenioService } from '../_services/convenio.service';
import { ProductoFormaDesembolsoConvenioComponent } from './producto/forma-desembolso/forma-desembolso-convenio/producto-forma-desembolso-convenio.component';
import { ProductoConvenioFormaDesembolsoService } from '../_services/producto-convenio-forma-desembolso.service';
import { HomologacionEstadoService } from '../_services/homologacion-estado.service';
import { HomologacionEstadoComponent } from './homologacion-estado/homologacion-estado.component';
import { AsignarGruposComponent } from './estructura-fisica/grupos/asignar-grupos.component';
import { AsignarGruposEditarComponent } from './estructura-fisica/grupos/asignar-grupos-editar.component';
import { GrupoService } from '../_services/grupo.service';
import { GrupoZonaService } from '../_services/grupo-zona.service';
import { GrupoZonaComponent } from './estructura-fisica/grupos/grupo-zona/grupo-zona.component';
import { FaseEstadoEditarComponent } from './fases/fase-estado-editar.component';
import { FaseEstadoComponent } from './fases/fase-estado.component';
import { FaseEditarComponent } from './fases/fase-editar.component';
import { FaseDetalleComponent } from './fases/fase-detalle.component';
import { FaseListadoComponent } from './fases/fase-listado.component';
import { ProductoEstadoRelacionNotificacionService } from '../_services/producto-estado-relacion-notificacion.service';
import { NotificacionesService } from '../_services/notificaciones.service';
import { FaseService } from '../_services/fase.service';
import { FaseEstadoService } from '../_services/fase-estado.service';
import { FaseEstadoRolService } from '../_services/fase-estado-rol.service';
import { AsignarGruposDetalleComponent } from './estructura-fisica/grupos/asignar-grupos-detalle.component';
import { ExcepcionesGmfListadoComponent } from './excepciones-gmf/excepciones-gmf-listado.component';
import { ExcepcionesGmfEditarComponent } from './excepciones-gmf/excepciones-gmf-editar.component';
import { CampaniaService } from '../_services/campania.service';
import { CampaniasDetalleComponent } from './campanias/campanias-detalle.component';
import { CampaniasEditarComponent } from './campanias/campanias-editar.component';
import { CampaniasListadoComponent } from './campanias/campanias-listado.component';
import { CampaniaDctoCicloService } from '../_services/campania-dcto-ciclo.service';
import { CampaniasDctoCiclosComponent } from './campanias/campanias-dcto-ciclos/campanias-dcto-ciclos.component';
import { CampaniaDctoMontoservice } from '../_services/campania-dcto-monto.service';
import { CampaniasDctoMontosComponent } from './campanias/campania-dctos-montos/campanias-dcto-montos.component';
import { ExcepcionGmfService } from '../_services/excepcion-gmf.service';
import { ExcepcionesGmfConfiguracionDestinosComponent } from './excepciones-gmf/excepciones-gmf-configuracion-destinos.component';
import { ExcepcionesGmfDestinosExentosComponent } from './excepciones-gmf/excepciones-gmf-destinos-exentos.component';
import { CambioPerfilComponent } from './cambio-perfil/cambio-perfil.component';
import { TerceroRiesgoService } from '../_services/tercero-riesgo.service';
import { CambioPerfilEditarComponent } from './cambio-perfil/cambio-perfil-editar/cambio-perfil-editar.component';
import { ExcepcionGMFDestinoService } from '../_services/excepcion-gmf-destino.service';
import { NivelesDescuentoTasaComponent } from './niveles/niveles-descuento-tasa.component';
import { NivelDescuentoService } from '../_services/nivel-descuento.service';
import { CampaniaDescuentoDestinoService } from '../_services/campania-descuento-destino.service';
import { CampaniaDescuentoDestinoComponent } from './campanias/campania-descuento-destino/campania-descuento-destino.component';
import { ExcepcionesGmfDetalleComponent } from './excepciones-gmf/excepciones-gmf-detalle.component';
import { EstadoBotonService } from '../_services/estado-boton.service';
import { EstadosBotonesComponent } from './estados/estados-botones.component';
import { ExcepcionGMFFormaDesembolsoService } from '../_services/excepcion-gmf-forma-desembolso.service';
import { ExcepcionGMFTipoCreditoService } from '../_services/excepcion-gmf-tipo-credito.service';
import { CampaniaDescuentoMoraComponent } from './campanias/campania-descuento-mora/campania-descuento-mora.component';
import { CampaniaDescuentoMoraService } from '../_services/campania-descuento-mora.service';
import { CampaniasDctoCiclosDetalleComponent } from './campanias/campanias-dcto-ciclos/campanias-dcto-ciclos-detalle.component';
import { CampaniasDctoMontosDetalleComponent } from './campanias/campania-dctos-montos/campanias-dcto-montos-detalle.component';
import { CampaniaDescuentoDestinoDetalleComponent } from './campanias/campania-descuento-destino/campania-descuento-destino-detalle.component';
import { CampaniaDescuentoMoraDetalleComponent } from './campanias/campania-descuento-mora/campania-descuento-mora-detalle.component';
import { SegmentoTipoVinculacionService } from '../_services/segmento-tipo-vinculacion.service';
import { SegmentoTipoVinculacionComponent } from './segmentos/segmento-tipo-vinculacion.component';
import { AlertaExcepcionService } from '../_services/alerta-excepcion.service';
import { ZonaLiberacionService } from '../_services/zona-liberacion.service';
import { ProductoConfirmacionVinculacionComponent } from './producto/confirmacion-vinculacion/producto-confirmacion-vinculacion.component';
import { ProductoConfirmacionVinculacionService } from '../_services/producto-confirmacion-vinculacion.service';
import { PerfilRiesgoEstadoService } from '../_services/perfil-riesgo-estado.service';
import { SistemaListadoComponent } from './sistemas/sistema-listado.component';
import { SistemaEditarComponent } from './sistemas/sistema-editar.component';
import { SistemaService } from '../_services/sistema.service';
import { ProductoReferenciaMinimaComponent } from './producto/referencia-minima/producto-referencia-minima.component';
import { ProductoVinculacionMinimoService } from '../_services/producto-vinculacion-minimo.service';
import { ProductoVinculacionMinimoReferenciaService } from '../_services/producto-vinculacion-minimo-referencia.service';
import { ExtensionesTelefonicasListadoComponent } from './extensiones-telefonicas/extensiones-telefonicas-listado.component';
import { ConfiguracionUrlExternaService } from '../_services/configuracion-url-externa.service';
import { ExtensionesTelefonicasEditarComponent } from './extensiones-telefonicas/extensiones-telefonicas-editar.component';
import { BancoErrorIntegracionListadoComponent } from './banco-error/banco-error-integracion-listado.component';
import { BancoErrorIntegracionEditarComponent } from './banco-error/banco-error-integracion-editar.component';
import { BancoErrorIntegracionDetalleComponent } from './banco-error/banco-error-integracion-detalle.component';
import { SolicitudBloqueoSarlaftService } from '../_services/solicitud-bloqueo-sarlaft.service';
import { SolicitudBloqueoSarlaftListadoComponent } from './solicitudes-bloqueo-sarlaft/solicitud-bloqueo-sarlaft-listado.component';
import { SolicitudService } from '../_services/solicitud.service';
import { SolicitudUcDesbloqueoService } from '../_services/solicitud-uc-desbloqueo.service';
import { SolicitudUnidadCreditoService } from '../_services/solicitud-unidad-credito.service';
import { ProductoReglaNegocioComponent } from './producto/regla-negocio/producto-regla-negocio.component';
import { ProductoReglaNegocioService } from '../_services/producto-regla-negocio.service';
import { ProductoAlertasListadoComponent } from './producto-alertas/producto-alertas-listado.component';
import { ProductoAlertasEditarComponent } from './producto-alertas/producto-alertas-editar.component';
import { ProductoAlertaComponent } from './producto-alertas/producto-alerta.component';
import { ProductoAlertaConfiguracionComponent } from './producto-alertas/producto-alerta-configuracion.component';
import { ProductoAlertaService } from '../_services/producto-alerta.service';
import { ProductoAlertaGrupoService } from '../_services/producto-alerta-grupo.service';
import { ProductoAlertaGrupoCondicionService } from '../_services/producto-alerta-grupo-condicion.service';
import { DescripcionErrorIntegracionService } from '../_services/descripcion-error-integracion.service';
import { AlfrescoComponent } from './alfresco/alfresco.component';
import { AlfrescoService } from '../_services/alfresco.service';
import { SolicitudUcBloqueoService } from '../_services/solicitud-uc-bloqueo.service';
import { IntegracionValidatorService } from '../utils/integracion-validator.service';
import { ClausuladoService } from '../_services/clausulado.service';
import { PerfilRiesgoEstadoAutomaticoService } from '../_services/perfil-riesgo-estado-automatico.service';
import { SolicitudUnidadCreditoTerceroRiesgoService } from '../_services/solicitud-unidad-credito-tercero-riesgo.service';
import { AliadoSucursalService } from '../_services/aliado-sucursal.service';
import { AliadosSucursalesListadoComponent } from './aliados/aliados-sucursales-listado.component';
import { AliadosSucursalesEditarComponent } from './aliados/aliados-sucursales-editar.component';
import { AliadosSucursalesDetalleComponent } from './aliados/aliados-sucursales-detalle.component';
import { AliadoService } from '../_services/aliado.service';
import { AliadosSucursalesCuposComponent } from './aliados/aliados-sucursales-cupos.component';
import { AliadoSucursalCupoService } from '../_services/aliado-sucursal-cupo.service';
import { AliadoUsuarioMovimientoService } from '../_services/aliado-usuario-movimiento.service';
import { ComunicationComponentsService } from '../_services/comunication-components.service';
import { FlujoVentaPasoService } from '../_services/flujo-venta-paso.service';
import { FlujoVentaPasoVinculacionService } from '../_services/flujo-venta-paso-vinculacion.service';
import { FlujoVentaPasoControlService } from '../_services/flujo-venta-paso-control.service';
import { FlujoVentaComponent } from './flujo-venta/flujo-venta.component';
import { FlujoVentaValidacionIdentidadComponent } from './flujo-venta/flujo-venta-validacion-identidad/flujo-venta-validacion-identidad.component';
import { FlujoVentaPasoAdjuntoService } from '../_services/flujo-venta-paso-adjunto.service';
import { FlujoVentaAgregarTablaComponent } from './flujo-venta/flujo-venta-comun/flujo-venta-agregar-tabla.component';
import { FlujoVentaComplementarioComponent } from './flujo-venta/flujo-venta-complementarios/flujo-venta-complementario.component';
import { FlujoVentaComplementarioAdjuntoComponent } from './flujo-venta/flujo-venta-complementarios/flujo-venta-complementario-adjunto/flujo-venta-complementario-adjunto.component';
import { FlujoVentaPasoComplementarioControlService } from '../_services/flujo-venta-paso-complementario-control.service';
import { PaqueteSegurosListadoComponent } from './paquete-seguros/paquete-seguros-listado.component';
import { PaqueteSegurosService } from '../_services/paquete-seguros.service';
import { PaqueteSegurosEditarComponent } from './paquete-seguros/paquete-seguros-editar.component';
import { PaqueteSegurosSegurosComponent } from './paquete-seguros/paquete-seguros-seguros.component';
import { PaqueteSegurosSegurosService } from '../_services/paquete-seguros-seguros.service';
import { PaqueteSegurosDetalleComponent } from './paquete-seguros/paquete-seguros-detalle.component';
import { PaqueteSegurosSegurosPlanesService } from '../_services/paquete-seguros-seguros-planes.service';
import { FlujoVentaAutorizacionesComponent } from './flujo-venta/flujo-venta-autorizaciones/flujo-venta-autorizaciones.component';
import { DatatableControlesComponent } from './flujo-venta/shared-flujo-venta/datatable-controles.component';
import { FlujoVentaOfertaComponent } from './flujo-venta/flujo-venta-ofertas/flujo-venta-oferta.component';
import { FlujoVentaTabViewComponent } from './flujo-venta/shared-flujo-venta/flujo-venta-tab-view.component';
import { FlujoVentaSegmentoComponent } from './flujo-venta/flujo-venta-segmentos/flujo-venta-segmento.component';
import { FlujoVentaRequisitoComponent } from './flujo-venta/flujo-venta-requisitos/flujo-venta-requisito.component';
import { FlujoVentaConsultaComponent } from './flujo-venta/flujo-venta-consultas/flujo-venta-consulta.component';
import { FlujoVentaHistorialCreditoComponent } from './flujo-venta/flujo-venta-historial-credito/flujo-venta-historial-credito.component';
import { FlujoVentaReferenciaComponent } from './flujo-venta/flujo-venta-referencias/flujo-venta-referencia.component';
import { FlujoVentaUnidadCreditoComponent } from './flujo-venta/flujo-venta-unidades-credito/flujo-venta-unidad-credito.component';
import { FlujoVentaFinProcesoComponent } from './flujo-venta/flujo-venta-fin-proceso/flujo-venta-fin-proceso.component';
import { ProductoHojaEvaluacionComponent } from './producto/hoja-evaluacion/producto-hoja-evaluacion.component';
import { ProductoHojaEvaluacionService } from '../_services/producto-hoja-evaluacion.service';
import { FlujoVentaPlantillaComponent } from './flujo-venta/flujo-venta-comun/flujo-venta-plantilla.component';
import { FlujoVentaReintentoComponent } from './flujo-venta/flujo-venta-comun/flujo-venta-reintento.component';
import { FlujoVentaPasoAutorizacionService } from '../_services/flujo-venta-paso-autorizacion.service';
import { FlujoVentaPasoReintentoService } from '../_services/flujo-venta-paso-reintento.service';
import { FlujoVentaPasoReintentoFuncionalidadControlService } from '../_services/flujo-venta-paso-reintento-funcionalidad-control.service';
import { MatrizIdentidadListadoComponent } from './matriz-identidad/matriz-identidad-listado.component';
import { MatrizIdentidadService } from '../_services/matriz-identidad.service';
import { MatrizIdentidadEditarComponent } from './matriz-identidad/matriz-identidad-editar.component';
import { ProductoRespaldosComponent } from './producto/respaldos/producto-respaldos.component';
import { ProductosRespaldosService } from '../_services/productos-respaldos.service';
import { SegmentoAdjuntoService } from '../_services/segmento-adjunto.service';
import { EstadoCausalService } from '../_services/estado-causal.service';
import { EstadosCausalComponent } from './estados/estados-causal.component';
import { FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitudService } from '../_services/flujo-venta-paso-reintento-funcionalidad-control-causal-solicitud.service';
import { FlujoVentaPasoReintentoCausalSolicitudService } from '../_services/flujo-venta-paso-reintento-causal-solicitud.service';
import { MatrizIdentidadAgregarComponent } from './matriz-identidad/matriz-identidad-agregar.component';
import { AdmgarComponent } from './administrador-garantias-idoneas/admgar.component';
import { AdmgarListadoComponent } from './administrador-garantias-idoneas/admgar-listado/admgar-listado.component';
import { AdmgarGarantiaIdoneaComponent } from './administrador-garantias-idoneas/admgar-garantia-idonea/admgar-garantia-idonea.component';
import { GarantiaService } from '../_services/garantia.service';
import { GarantiaIdoneasListadoComponent } from './garantias-idoneas/garantia-idoneas-listado.component';
import { GarantiaIdoneasService } from '../_services/garantia-idoneas.service';
import { GarantiaIdoneasEditarComponent } from './garantias-idoneas/garantia-idoneas-editar.component';
import { GarantiaIdoneasDestinosComponent } from './garantias-idoneas/destinos/garantia-idoneas-destinos.component';
import { ListaService } from '../_services/lista.service';
import { GarantiaIdoneasDestinosService } from '../_services/garantia-idoneas-destinos.service';
import { GarantiaIdoneasMunicipioService } from '../_services/garantia-idoneas-municipio.service';
import { GarantiaIdoneasMunicipiosComponent } from './garantias-idoneas/municipio/garantia-idoneas-municipios.component';
import { GarantiaIdoneasActividadesComponent } from './garantias-idoneas/actividades/garantia-idoneas-actividades.component';
import { GarantiaIdoneasActividadesService } from '../_services/garantia-idoneas-actividades.service';
import { GarantiaIdoneasProductoService } from '../_services/garantia-idoneas-producto.service';
import { GarantiaIdoneasProductoComponent } from './garantias-idoneas/producto/garantia-idoneas-producto.component';
import { GarantiaIdoneasPeriodoGraciaComponent } from './garantias-idoneas/periodo-gracia/garantia-idoneas-periodo-gracia.component';
import { GarantiaIdoneasPeriodoGraciaService } from '../_services/garantia-idoneas-periodo-gracia.service';
import { GarantiaIdoneasPeriodoGraciaConceptosFacturacionService } from '../_services/garantia-idoneas-periodo-gracia-conceptos-facturacion.service';
import { GarantiaIdoneasDetalleComponent } from './garantias-idoneas/garantia-idoneas-detalle.component';
import { TipoProductoresListadoComponent } from './tipos-productores/tipo-productores-listado.component';
import { TipoProductoresEditarComponent } from './tipos-productores/tipo-productores-editar.component';
import { TipoProductoresService } from '../_services/tipo-producto.service';
import { TipoProductoresDetalleComponent } from './tipos-productores/tipo-productores-detalle.component';
import { GarantiaIdoneasTipoProductoComponent } from './garantias-idoneas/tipo-producto/garantia-idoneas-tipo-producto.component';
import { GarantiaIdoneasTipoProductoService } from '../_services/garantia-idoneas-tipo-producto.service';
import { RequisitoGarantiaCantidadService } from '../_services/requisito-garantia-cantidad.service';
import { RequisitoGarantiaCantidadTipoVinculacionService } from '../_services/requisito-garantia-cantidad-tipo-vinculacion.service';
import { RequisitosTipoVinculacionComponent } from './requisitos/requisito-tipo-vinculacion/requisitos-tipo-vinculacion.component';
import { RequisitoGarantiaModalidadService } from '../_services/requisito-garantia-modalidad.service';
import { RequisitoGarantiaTipoRespaldoService } from '../_services/requisito-garantia-tipo-respaldo.service';
import { CanalEstadoFormComponent } from './configuracion-canal-estado/canal-estado-form.component';
import {ConfiguracionCanalEstadoListadoComponent} from './configuracion-canal-estado/configuracion-canal-estado-listado.component';
import {ConfiguracionesCanalesService} from '../_services/configuraciones-canales.service';
import {ProductoFlujoVentaPasoComponent} from './producto/flujo-venta-paso/producto-flujo-venta-paso.component';
import {ProductosFlujoVentaPasosService} from '../_services/productos-flujo-venta-pasos.service';
import {ProductoCategoriasComponent} from './producto/producto-categorias/producto-categorias.component';
import {ProductosCategoriasService} from '../_services/productos-categorias.service';
import {RequisitosRespaldosTipoVincuracionService} from '../_services/requisitos-respaldos-tipo-vincuracion.service';
import {RequisitosRespaldosProductosService} from '../_services/requisitos-respaldos-productos.service';
import {RequisitosRespaldosActividadesService} from '../_services/requisitos-respaldos-actividades.service';
import { ProductoSeguroTipoConstruccionService } from '../_services/producto-seguro-tipo-construccion.service';
import { ProductoSeguroClaseViviendaService } from '../_services/producto-seguro-clase-vivienda.service';
import { ProductoSeguroTipoDireccionService } from '../_services/producto-seguro-tipo-direccion.service';
import { CanalEstadoPasoComponent } from './configuracion-canal-estado/canal-estado-paso.component';
import { ConfiguracionCanalFlujoVentaPasoService } from '../_services/configuracion-canal-flujo-venta-paso.service';
import { CanalEstadoPasoControlProductoComponent } from './configuracion-canal-estado/canal-estado-paso-control-producto.component';
import { ConfiguracionCanalFlujoVentaPasoControlProductoService } from '../_services/configuracion-canal-flujo-venta-paso-control-producto.service';
import {CanalEstadoDetalleComponent} from './configuracion-canal-estado/canal-estado-detalle.component';
import { FlujoVentaIntegracionesComponent } from './flujo-venta/flujo-venta-comun/flujo-venta-integraciones/flujo-venta-integraciones.component';
import { RequisitoProductoComponent } from './requisitos/requisito-producto/requisito-producto.component';
import { RolFuncionalitiesServices } from '../_services/rol-funcionalidad.service';
import { EstadoAdjuntoService } from '../_services/estado-adjunto.service';
import { FrecuenciasCuotasComponent } from './producto/frecuencias/frecuencias-cuotas/frecuencias-cuotas.component';
import { ProductoFrecuenciaCuotaService } from '../_services/producto-frecuencia-cuota.service';
import {ProductoSubdestinoMontoAliadoService} from '../_services/producto-subdestino-monto-aliado.service';
import {ProductoSubdestinoService} from '../_services/producto-subdestino.service';
import {ProductoSubdestinoMontoService} from '../_services/producto-subdestino-monto.service';
import { PoliticasComponent } from './politicas/politicas.component';
import { PolitcasFormularioComponent } from './politicas/politcas-formulario/politcas-formulario.component';
import { PolitcasFormularioDescarteComponent } from './politicas/politcas-formulario/politcas-formulario-descarte/politcas-formulario-descarte.component';
import { PoliticaPlanteamientoPoliticaComponent } from './politicas/politcas-formulario/politica-planteamiento-politica/politica-planteamiento-politica.component';
import { PlantillaParametroService } from '../_services/plantilla-parametro.service';
import { PoliticasPlanteamientosPoliticasService } from '../_services/politicas-planteamientos-politicas.service';
import {ProductoPoliticaAlertaComponent} from './producto/politica-alerta/producto-politica-alerta.component';
import {PoliticaService} from '../_services/politica.service';
import {ProductoPoliticaAlertaService} from '../_services/producto-politica-alerta.service';
import {CanalEstadoPasoPoliticaProductoComponent} from './configuracion-canal-estado/canal-estado-paso-politica-producto.component';
import {ConfiguracionCanalFlujoVentaPasoPoliticaProductoService} from '../_services/configuracion-canal-flujo-venta-paso-politica-producto.service';
import { FvRestriccionesPerfilXVinculacionComponent } from './flujo-venta/shared-flujo-venta/fv-restricciones-perfil-x-vinculacion/fv-restricciones-perfil-x-vinculacion.component';
import { FlujoVentaUnidadFamiliarComponent } from './flujo-venta/flujo-venta-unidad-familiar/flujo-venta-unidad-familiar.component';
import { FlujoVentaRespaldosComponent } from './flujo-venta/flujo-venta-respaldos/flujo-venta-respaldos.component';
import { FlujoVentaUnidadProductivaComponent } from './flujo-venta/flujo-venta-unidad-productiva/flujo-venta-unidad-productiva.component';
import { FlujoVentaHojaEvaluacionComponent } from './flujo-venta/flujo-venta-hoja-evaluacion/flujo-venta-hoja-evaluacion.component';
import { FlujoVentaPoliticasComponent } from './flujo-venta/flujo-venta-politicas/flujo-venta-politicas.component';
import { FlujoVentaListadoAdjuntosComponent } from './flujo-venta/flujo-venta-listado-adjuntos/flujo-venta-listado-adjuntos.component';
import { FlujoVentaPasoRestriccionPerfilVinculacionService } from '../_services/flujo-venta-paso-restriccion-perfil-vinculacion.service';
import { CanalesRestriccionesGestionEstadosComponent } from './canales/canales-restricciones-gestion-estados/canales-restricciones-gestion-estados.component';
import { UnidadesMedidaComponent } from './unidades-medida/unidades-medida.component';
import { UnidadesMedidaListadoComponent } from './unidades-medida/unidades-medida-listado/unidades-medida-listado.component';
import { UnidadMedidaFormComponent } from './unidades-medida/unidad-medida-form/unidad-medida-form.component';
import { FlujoVentaSeguroComponent } from './flujo-venta/flujo-venta-seguro/flujo-venta-seguro.component';
import { ReglasNegocioComponent } from './reglas-negocio/reglas-negocio.component';
import { ProductosPeriodosGraciasService } from '../_services/productos-periodos-gracias.service';
import { ReglasNegocioVinculacionService } from '../_services/reglas-negocio-vinculacion.service';
import { ReglasNegocioPlazoService } from '../_services/reglas-negocio-plazo.service';
import { ProductoRestriccionSubdestinoComponent } from './producto/restricciones/producto-restriccion-subdestino/producto-restriccion-subdestino.component';
import { ProductosEstadosRelacionesTiposPreaprobadosService } from '../_services/productos-estados-relaciones-tipos-preaprobados.service';
import {CrdModule} from '../CRD/crd.module';
import { AsignarScoreComponent } from './perfiles-riesgo/asignar-score/asignar-score.component';
import { PerfilesRiesgosScoreService } from '../_services/perfiles-riesgos-score.service';
import { ProductoRestriccionActividadComponent } from './producto/restricciones/producto-restriccion-actividad/producto-restriccion-actividad.component';
import { PlanCargoService } from '../_services/plan-cargo.service';
import { PlanCargoConceptoFacturacionService } from '../_services/plan-cargo-concepto-facturacion.service';
import { ProductoPlanCargoService } from '../_services/producto-plan-cargo.service';
import { PlanesCargosListadosComponent } from './planes-cargos/planes-cargos-listados/planes-cargos-listados.component';
import { PlanesCargosEditarComponent } from './planes-cargos/planes-cargos-editar/planes-cargos-editar.component';
import { PlanesCargosDetalleComponent } from './planes-cargos/planes-cargos-detalle/planes-cargos-detalle.component';
import { PlanesCargosConceptosComponent } from './planes-cargos/planes-cargos-editar/planes-cargos-conceptos/planes-cargos-conceptos.component';
import { ProductoPlanesCargosComponent } from './producto/producto-planes-cargos/producto-planes-cargos.component';
import { PoliticasDurasListadoComponent } from './politicas-duras/politicas-duras-listado.component';
import { PoliticasDurasEditarComponent } from './politicas-duras/politicas-duras-editar/politicas-duras-editar.component';
import { PoliticasDurasDetalleComponent } from './politicas-duras/politicas-duras-detalle/politicas-duras-detalle.component';
import { DialogService } from 'primeng/dynamicdialog';
import { PagaduriaComponent } from './pagaduria/pagaduria-editar.component';
import { PagaduriaListadoComponent } from './pagaduria/pagaduria-listado/pagaduria-listado.component';
import {AuditoriaControlService} from '../_services/auditoria-control.service';
import { PagaduriaDetalleComponent } from './pagaduria/pagaduria-detalle/pagaduria-detalle.component';
import { ComisionFreelanceListadoComponent } from './comision-freelance/comision-freelance-listado.component';
import { ComisionFreelanceEditarComponent } from './comision-freelance/comision-freelance-editar/comision-freelance-editar.component';
import { ComisionFreelanceDetalleComponent } from './comision-freelance/comision-freelance-detalle/comision-freelance-detalle.component';
import { ComisionFreelanceTarifaComponent } from './comision-freelance/comision-freelance-editar/comision-freelance-tarifa/comision-freelance-tarifa.component';
import { UsuarioComisionFreelanceTarifaService } from '../_services/usuario-comision-freelance-tarifa.service';
import {PagaduriaService} from '../_services/pagaduria.service';
import { CobrosPerfilesRiesgosComponent } from './garantias-idoneas/cobros-perfiles-riesgos/cobros-perfiles-riesgos.component';
import { FlujoVentaMonetizacionComponent } from './flujo-venta/flujo-venta-monetizacion/flujo-venta-monetizacion.component';
import { HomologacionPlanesCargosListadoComponent  } from './homologacion-planes-cargos/homologacion-planes-cargos-listado.component';
import { HomologacionPlanesCargosEditarComponent } from './homologacion-planes-cargos/homologacion-planes-cargos-editar/homologacion-planes-cargos-editar.component';
import { ConveniosPlanCargoListadoComponent } from './convenios-planes-cargos/convenios-plan-cargo-listado.component';
import { ConveniosPlanCargoEditarComponent } from './convenios-planes-cargos/convenios-plan-cargo-editar/convenios-plan-cargo-editar.component';
import { ConveniosPlanCargosDetalleComponent } from './convenios-planes-cargos/convenios-plan-cargos-detalle/convenios-plan-cargos-detalle.component';
import { ComiteCreditoComponent } from './comite-credito/comite-credito/comite-credito.component';
import { ProductoReferenciasParentescosService } from '../_services/producto-referencias-parentescos.service';
import { ReferenciaMetodoDesembolsoComponent } from './producto/referencia-metodo-desembolso/referencia-metodo-desembolso.component';
import { FlujoVentaValidacionPlataformaDigitalComponent } from './flujo-venta/flujo-venta-validacion-plataforma-digital/flujo-venta-validacion-plataforma-digital.component';
import { SegurosCoberturasComponent } from './seguro/seguros-coberturas/seguros-coberturas.component';
import {SeguroCoberturaService} from '../_services/seguro-cobertura.service';
import { FlujoVentaAtributosValidarFacetecComponent } from './flujo-venta/flujo-venta-atributos-validar-facetec/flujo-venta-atributos-validar-facetec.component';
import { FlujoVentaPoliticasConfiguradasComponent } from './flujo-venta/shared-flujo-venta/flujo-venta-politicas-configuradas/flujo-venta-politicas-configuradas.component';
import { ServidoresAlfrescoComponent } from './servidores-alfresco/servidores-alfresco.component';
import { ServidoresAlfrescoEditarComponent } from './servidores-alfresco/servidores-alfresco-editar/servidores-alfresco-editar.component';
import { ServidorAlfrescoService } from '../_services/servidor-alfresco.service';
import { SarlaftComponent } from './sarlaft/sarlaft.component';
import { SarlaftVariablesComponent } from './sarlaft/sarlaft-variables/sarlaft-variables.component';
import { SarlaftNivelesComponent } from './sarlaft/sarlaft-niveles/sarlaft-niveles.component';
import { SarlaftEditarNivelesComponent } from './sarlaft/sarlaft-niveles/sarlaft-editar-niveles/sarlaft-editar-niveles.component';
import { SarlaftEditarVariablesComponent } from './sarlaft/sarlaft-variables/sarlaft-editar-variables/sarlaft-editar-variables.component';
import { SegmentoOcupacionesComponent } from './segmentos/segmento-ocupaciones/segmento-ocupaciones.component';
import {OcupacionesService} from '../_services/ocupaciones.service';
import { SarlaftVariablesCondicionesComponent } from './sarlaft/sarlaft-variables/sarlaft-variables-condiciones/sarlaft-variables-condiciones.component';
import { SarlaftCondicionesService } from '../_services/sarlaft-condiciones.service';
import { SarlaftModalSimuladorComponent } from './sarlaft/sarlaft-modal-simulador/sarlaft-modal-simulador.component';
import { UsuarioTiposCreditosService } from '../_services/usuario-tipos-creditos.service';
import { FlujoVentaComiteCreditoComponent } from './flujo-venta/flujo-venta-comite-credito/flujo-venta-comite-credito.component';
import { TasasVariablesListadoComponent } from './administrador-tasas-variables/tasas-variables-listado/tasas-variables-listado.component';
import { TasasVariablesEditarComponent } from './administrador-tasas-variables/tasas-variables-editar/tasas-variables-editar.component';
import { TasasVariablesEditarTasaComponent } from './administrador-tasas-variables/tasas-variables-editar-tasa/tasas-variables-editar-tasa.component';
import { DetalleTasaCondicionComponent } from './administrador-tasas-variables/modales/detalle-tasa-condicion/detalle-tasa-condicion.component';
import { AprobacionTasaComponent } from './administrador-tasas-variables/modales/aprobacion-tasa/aprobacion-tasa.component';
import { VerDetalleTasasComponent } from './administrador-tasas-variables/ver-detalle-tasas/ver-detalle-tasas.component';
import { PoliticaMatrizComponent } from './politicas/politcas-formulario/politica-matriz/politica-matriz.component';
import { PoliticaTalanqueraComponent } from './politicas/politcas-formulario/politica-talanquera/politica-talanquera.component';
import { MetaVentaSegurosComponent } from './seguro/meta-venta-seguros/meta-venta-seguros.component';
import { MetaVentaSegurosService } from '../_services/meta-venta-seguros.service';
import { ModalidadesFactorCrezcamosComponent } from './modalidades/modalidades-factor-crezcamos/modalidades-factor-crezcamos.component';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {CommonModule} from '@angular/common';
import { SimuladorPantallaGeneralComponent } from './simulador-credito/simulador-pantalla-general.component';
import { PerfilCrezcamosModule } from './perfil-crezcamos/perfil-crezcamos.module';
import {SortablejsModule} from 'ngx-sortablejs-v16';
import {ProductoMontosTasasComponent} from './producto/montos-tasas/producto-montos-tasas.component';
import {ProductoPlazosComponent} from './producto/montos-tasas/plazos/producto-plazos.component';
import {ProductoMontosComponent} from './producto/montos-tasas/montos/producto-montos.component';
import {ProductoMontosPlazosComponent} from './producto/montos-tasas/montos-pazos/producto-montos-plazos.component';
import {TopeInversionComponent} from './tope-inversion/tope-inversion.component';
import {TopeInversionDetalleComponent} from './tope-inversion/tope-inversion-detalle/tope-inversion-detalle.component';
import {TopeInversionEditarComponent} from './tope-inversion/tope-inversion-editar/tope-inversion-editar.component';
import { VigenciasAplComponent } from './vigencias/vigencias-apl.component';
import { AdministrationDocumentsAddComponent } from './vigencias/vigencias-documentos/administration-documents-add.component';
import { AdministrationDocumentsDetailComponent } from './vigencias/vigencias-documentos/administration-documents-detail.component';
import { AdministrationDocumentsComponent } from './vigencias/vigencias-documentos/administration-documents.component';
import { ValidityRequestsAddComponent } from './vigencias/vigencias-solicitud/validity-requests-add.component';
import { ValidityRequestsComponent } from './vigencias/vigencias-solicitud/validity-requests.component';
import { ValidityEmployeesAddComponent } from './vigencias/vigencias-tercero/validity-employees-add.component';
import { ValidityEmployeesComponent } from './vigencias/vigencias-tercero/validity-employees.component';
import {DineroPipe} from "../_pipes/dinero.pipe";
import {ProductoGarantiaIdoneaComponent} from './producto/producto-garantia-idonea/producto-garantia-idonea.component';
import {SegurosBienesComponent} from './seguro/seguros-bienes/seguros-bienes.component';
import {ProductoPasarelaComponent} from './producto/producto-pasarela/producto-pasarela.component';
import {ProductoPasarelaTarifasComponent} from './producto/producto-pasarela/producto-pasarela-tarifas/producto-pasarela-tarifas.component';
import {ProductoPasarelaContratosComponent} from './producto/producto-pasarela/producto-pasarela-contratos/producto-pasarela-contratos.component';
import {ProductoAdjuntosComponent} from './producto/producto-adjuntos/producto-adjuntos.component';
import {AdmsbListadoComponent} from './administrador-servicios-bancarios/admsb-listado/admsb-listado.component';
import {AdmsbTitularComponent} from './administrador-servicios-bancarios/admsb-titular/admsb-titular.component';
import {AdmsbTarifasComponent} from './administrador-servicios-bancarios/admsb-tarifas/admsb-tarifas.component';
import {AdmsbEncabezadoComponent} from './administrador-servicios-bancarios/admsb-titular/secciones/admsb-encabezado/admsb-encabezado.component';
import {AdmsbUnidadProductivaComponent} from './administrador-servicios-bancarios/admsb-titular/secciones/admsb-unidad-productiva/admsb-unidad-productiva.component';
import {AdmsbTarifasTablaComponent} from './administrador-servicios-bancarios/admsb-titular/secciones/admsb-tarifas-tabla/admsb-tarifas-tabla.component';
import {AdmsbAdjuntosTablaComponent} from './administrador-servicios-bancarios/admsb-titular/secciones/admsb-adjuntos-tabla/admsb-adjuntos-tabla.component';
import {AdmsbContratosTablaComponent} from './administrador-servicios-bancarios/admsb-titular/secciones/admsb-contratos-tabla/admsb-contratos-tabla.component';
import {AdmsbContactosTablaComponent} from './administrador-servicios-bancarios/admsb-titular/secciones/admsb-contactos-tabla/admsb-contactos-tabla.component';
import { FlujoVentaRecaudoComponent } from './flujo-venta/flujo-venta-recaudo/flujo-venta-recaudo.component';
import { FlujoVentaContratoComponent } from './flujo-venta/flujo-venta-contrato/flujo-venta-contrato.component';


// @ts-ignore
@NgModule({
    imports: [
        AplRoutingModule,
        SharedModule,
        FormSharedModule,
        DetalleTerceroModule,
        LocalizacionesModule,
        CrdModule,
        ConfirmDialogModule,
        DialogModule,
        CommonModule,
        PerfilCrezcamosModule,
        SortablejsModule.forRoot({
          animation: 100,
        })
    ],
    declarations: [
        CanalesListadoComponent,
        CanalesDetalleComponent,
        CanalesEditarComponent,
        CanalesProductosComponent,
        CanalesRolesComponent,
        SegmentoListadoComponent,
        SegmentoDetalleComponent,
        SegmentoActividadesComponent,
        SegmentoProductosComponent,
        NivelesListadoComponent,
        NivelesAgregarComponent,
        NivelesDetalleComponent,
        NivelesRangoUsuarioComponent,
        AliadosListadoComponent,
        BancoPreguntasListadoComponent,
        BancoPreguntasEditarComponent,
        AliadosListadoComponent,
        ZonasListadoComponent,
        ZonasEditarComponent,
        ZonasDetalleComponent,
        ZonasTransferenciaComponent,
        CuestionariosListadoComponent,
        AliadosSeleccionarComponent,
        AliadosUsuariosListadoComponent,
        AliadosUsuariosEditarComponent,
        AliadosUsuariosDetalleComponent,
        EstructuraFisicaListadoComponent,
        EstructuraFisicaAsignarEjecutivoComponent,
        AgendaListadoComponent,
        AgendaAsignarComponent,
        CuestionariosEditarComponent,
        AgendaDetalleComponent,
        EstadosListadoComponent,
        EstadosEditarComponent,
        EstadosDetalleComponent,
        PerfilesRiesgoListadoComponent,
        PerfilesRiesgoEditarComponent,
        PerfilesRiesgoDetalleComponent,
        PerfilesRiesgoTasaComponent,
        PerfilesRiesgoCicloComponent,
        CuestionariosPreguntaComponent,
        CuestionariosPreguntaBancoComponent,
        CuestionariosDetalleComponent,
        CuestionariosPreguntaRespuestaComponent,
        BancoPreguntasDetalleComponent,
        ProductoListadoComponent,
        ProductosTroncalComponent,
        ProductosTroncalEditarComponent,
        ProductosTroncalProductosComponent,
        ProductosTroncalDetalleComponent,
        ProductoEditarComponent,
        ProductoDestinoComponent,
        ProductoMontoComponent,
        ProductoDestinoMontoComponent,
        ProductoRenovacionComponent,
        ProductoFrecuenciaComponent,
        ProductoReferenciaComponent,
        ProductoGarantiaComponent,
        ProductoHistorialComponent,
        EstructuraFisicaDetalleComponent,
        ProductoEstadoAliadoComponent,
        ProductoEstadoAliadoRelacionComponent,
        ProductoEstadoAliadoRolComponent,
        ProductoActividadAliadoListadoComponent,
        ProductoActividadAliadoDetalleComponent,
        ProductoActividadAliadoEditarComponent,
        ConceptoFacturacionListadoComponent,
        ConceptoFacturacionDetalleComponent,
        ConceptoFacturacionEditarComponent,
        ControlListadoComponent,
        ControlEditarComponent,
        PalabraClaveListadoComponent,
        PalabraClaveDetalleComponent,
        PalabraClaveEditarComponent,
        SincronizacionListadoComponent,
        SincronizacionEditarComponent,
        ProductoMontoAliadoComponent,
        ProductoDetalleComponent,
        PoliticasCreditoListadoComponent,
        PoliticasCreditoEditarComponent,
        PoliticasCreditoOficinasComponent,
        PoliticasCreditoSegmentoComponent,
        PoliticasCreditoDetalleComponent,
        ProductoFrecuenciaAliadoComponent,
        ProductoControlComponent,
        ProductoCuestionarioComponent,
        EstadosRolComponent,
        TipoCausalListadoComponent,
        TipoCausalEditarComponent,
        TipoOcupacionConfiguracionListadoComponent,
        TipoOcupacionConfiguracionEditarComponent,
        TipoOcupacionConfiguracionDetalleComponent,
        SegmentoEditarComponent,
        SegmentoIngresosComponent,
        SegmentoEndeudamientoComponent,
        SegmentoActivosComponent,
        SegmentoEmpleadosComponent,
        SegmentoSectorComponent,
        SegmentoTipoContratoComponent,
        ProductoAutorizacionComponent,
        RequisitosListadoComponent,
        RequisitosEditarComponent,
        RequisitosRespaldosComponent,
        RequisitosDetalleComponent,
        CentralRiesgoIntegracionEditarComponent,
        CentralRiesgoIntegracionListadoComponent,
        CentralRiesgoIntegracionDetalleComponent,
        ProductoVoluntadPagoComponent,
        CuentaContableComponent,
        SeguroListadoComponent,
        SeguroEditarComponent,
        SeguroPlanComponent,
        SeguroDetalleComponent,
        ProductoSeguroAnalizamosComponent,
        TipoRespaldoListadoComponent,
        TipoRespaldoEditarComponent,
        TipoRespaldoCategoriaComponent,
        TipoRespaldoSubcategoriaComponent,
        TipoRespaldoClaseComponent,
        EstructuraOficinaComponent,
        TipoRespaldoDetalleComponent,
        TipoRespaldoDetalleSubcategoriaComponent,
        VinculacionTerceroComponent,
        MenuVisitaComponent,
        VinculacionTerceroVinculacionComponent,
        VinculacionTerceroOcupacionComponent,
        ProcesoProductivoListadoComponent,
        ProcesoProductivoEditarComponent,
        ProcesoProductivoVariableIncidenciaComponent,
        ProcesoProductivoDetalleComponent,
        PlagaListadoComponent,
        PlagaEditarComponent,
        PlagaProductoComercialComponent,
        PlagaProductoComponent,
        VinculacionTerceroDetalleSubmenuComponent,
        PlagaDetalleComponent,
        FormaDesembolsoComponent,
        ProductoFormaDesembolsoComponent,
        PlagaDetalleComponent,
        ModalidadesDetalleComponent,
        ModalidadesEditarComponent,
        ModalidadesListadoComponent,
        AlertaListadoComponent,
        AlertaEditarComponent,
        AlertaDetalleComponent,
        VinculacionEstadoFinancieroComponent,
        ModalidadesListadoComponent,
        ModalidadesAutorizacionesComponent,
        ProductoRestriccionComponent,
        ProductoRestriccionBarriosComponent,
        ModalidadesTasasComponent,
        ModalidadesCalificacionesComponent,
        ProductoDesembolsoListadoComponent,
        ProductoDesembolsoDetalleComponent,
        ProductoDesembolsoEditarComponent,
        HomologacionEstadoComponent,
        FaseListadoComponent,
        FaseDetalleComponent,
        FaseEditarComponent,
        FaseEstadoComponent,
        FaseEstadoEditarComponent,
        ConveniosComponent,
        NivelesRangoTasaUsuarioComponent,
        ConveniosEditarComponent,
        ConveniosDetalleComponent,
        ProductoFormaDesembolsoConvenioComponent,
        AsignarGruposComponent,
        GrupoZonaComponent,
        AsignarGruposEditarComponent,
        AsignarGruposDetalleComponent,
        ExcepcionesGmfListadoComponent,
        ExcepcionesGmfEditarComponent,
        ExcepcionesGmfListadoComponent,
        CampaniasDetalleComponent,
        CampaniasEditarComponent,
        CampaniasListadoComponent,
        ExcepcionesGmfConfiguracionDestinosComponent,
        ExcepcionesGmfDestinosExentosComponent,
        CambioPerfilComponent,
        CambioPerfilEditarComponent,
        NivelesDescuentoTasaComponent,
        CampaniaDescuentoDestinoComponent,
        ExcepcionesGmfDetalleComponent,
        NivelesDescuentoTasaComponent,
        EstadosBotonesComponent,
        CampaniasListadoComponent,
        CampaniasDctoCiclosComponent,
        CampaniasDctoMontosComponent,
        CampaniasDctoCiclosDetalleComponent,
        CampaniasDctoMontosDetalleComponent,
        CampaniasDctoMontosComponent,
        CampaniaDescuentoMoraComponent,
        CampaniaDescuentoDestinoDetalleComponent,
        CampaniaDescuentoMoraDetalleComponent,
        SegmentoTipoVinculacionComponent,
        ProductoConfirmacionVinculacionComponent,
        SistemaListadoComponent,
        SistemaEditarComponent,
        ProductoReferenciaMinimaComponent,
        ProductoConfirmacionVinculacionComponent,
        ExtensionesTelefonicasListadoComponent,
        ExtensionesTelefonicasEditarComponent,
        BancoErrorIntegracionListadoComponent,
        BancoErrorIntegracionEditarComponent,
        BancoErrorIntegracionDetalleComponent,
        SolicitudBloqueoSarlaftListadoComponent,
        ProductoReglaNegocioComponent,
        SolicitudBloqueoSarlaftListadoComponent,
        ProductoAlertasListadoComponent,
        ProductoAlertasEditarComponent,
        ProductoAlertaComponent,
        ProductoAlertaConfiguracionComponent,
        AlfrescoComponent,
        AliadosSucursalesListadoComponent,
        AliadosSucursalesEditarComponent,
        AliadosSucursalesDetalleComponent,
        AliadosSucursalesCuposComponent,
        FlujoVentaComponent,
        FlujoVentaAgregarTablaComponent,
        FlujoVentaComplementarioComponent,
        FlujoVentaComplementarioAdjuntoComponent,
        PaqueteSegurosListadoComponent,
        PaqueteSegurosEditarComponent,
        PaqueteSegurosSegurosComponent,
        PaqueteSegurosDetalleComponent,
        FlujoVentaComplementarioAdjuntoComponent,
        FlujoVentaValidacionIdentidadComponent,
        FlujoVentaOfertaComponent,
        FlujoVentaAutorizacionesComponent,
        DatatableControlesComponent,
        FlujoVentaTabViewComponent,
        FlujoVentaSegmentoComponent,
        FlujoVentaRequisitoComponent,
        FlujoVentaConsultaComponent,
        FlujoVentaHistorialCreditoComponent,
        FlujoVentaReferenciaComponent,
        FlujoVentaUnidadCreditoComponent,
        FlujoVentaFinProcesoComponent,
        ProductoHojaEvaluacionComponent,
        MatrizIdentidadListadoComponent,
        MatrizIdentidadEditarComponent,
        ProductoRespaldosComponent,
        FlujoVentaPlantillaComponent,
        FlujoVentaReintentoComponent,
        ProductoHojaEvaluacionComponent,
        EstadosCausalComponent,
        ProductoHojaEvaluacionComponent,
        MatrizIdentidadAgregarComponent,
        AdmgarComponent,
        AdmgarListadoComponent,
        AdmgarGarantiaIdoneaComponent,
        GarantiaIdoneasListadoComponent,
        GarantiaIdoneasEditarComponent,
        GarantiaIdoneasDestinosComponent,
        GarantiaIdoneasMunicipiosComponent,
        GarantiaIdoneasActividadesComponent,
        GarantiaIdoneasProductoComponent,
        GarantiaIdoneasPeriodoGraciaComponent,
        GarantiaIdoneasDetalleComponent,
        TipoProductoresListadoComponent,
        TipoProductoresEditarComponent,
        TipoProductoresDetalleComponent,
        GarantiaIdoneasTipoProductoComponent,
        RequisitosTipoVinculacionComponent,
        CanalEstadoFormComponent,
        ConfiguracionCanalEstadoListadoComponent,
        ProductoFlujoVentaPasoComponent,
        ProductoCategoriasComponent,
        CanalEstadoPasoComponent,
        CanalEstadoPasoControlProductoComponent,
        CanalEstadoDetalleComponent,
        FlujoVentaIntegracionesComponent,
        RequisitoProductoComponent,
        FrecuenciasCuotasComponent,
        PoliticasComponent,
        PolitcasFormularioComponent,
        PolitcasFormularioDescarteComponent,
        PoliticaPlanteamientoPoliticaComponent,
        ProductoPoliticaAlertaComponent,
        CanalEstadoPasoPoliticaProductoComponent,
        FvRestriccionesPerfilXVinculacionComponent,
        FlujoVentaUnidadFamiliarComponent,
        FlujoVentaRespaldosComponent,
        FlujoVentaUnidadProductivaComponent,
        FlujoVentaHojaEvaluacionComponent,
        FlujoVentaPoliticasComponent,
        FlujoVentaListadoAdjuntosComponent,
        CanalesRestriccionesGestionEstadosComponent,
        UnidadesMedidaComponent,
        UnidadesMedidaListadoComponent,
        UnidadMedidaFormComponent,
        FlujoVentaSeguroComponent,
        ReglasNegocioComponent,
        ProductoRestriccionSubdestinoComponent,
        AsignarScoreComponent,
        ProductoRestriccionActividadComponent,
        PlanesCargosListadosComponent,
        PlanesCargosEditarComponent,
        PlanesCargosDetalleComponent,
        PlanesCargosConceptosComponent,
        ProductoPlanesCargosComponent,
        PoliticasDurasListadoComponent,
        PoliticasDurasEditarComponent,
        PoliticasDurasDetalleComponent,
        PagaduriaComponent,
        PagaduriaListadoComponent,
        PagaduriaCondicionesListadoComponent,
        PagaduriaCondicionesEditarComponent,
        PagaduriaDetalleComponent,
        ComisionFreelanceListadoComponent,
        ComisionFreelanceEditarComponent,
        ComisionFreelanceDetalleComponent,
        ComisionFreelanceTarifaComponent,
        CobrosPerfilesRiesgosComponent,
        HomologacionPlanesCargosListadoComponent,
        HomologacionPlanesCargosEditarComponent,
        FlujoVentaMonetizacionComponent,
        ConveniosPlanCargoListadoComponent,
        ConveniosPlanCargoEditarComponent,
        ConveniosPlanCargosDetalleComponent,
        ComiteCreditoComponent,
        ReferenciaMetodoDesembolsoComponent,
        FlujoVentaValidacionPlataformaDigitalComponent,
        SegurosCoberturasComponent,
        FlujoVentaAtributosValidarFacetecComponent,
        FlujoVentaPoliticasConfiguradasComponent,
        ServidoresAlfrescoComponent,
        ServidoresAlfrescoEditarComponent,
        SarlaftComponent,
        SarlaftVariablesComponent,
        SarlaftNivelesComponent,
        SarlaftEditarNivelesComponent,
        SarlaftEditarVariablesComponent,
        SegmentoOcupacionesComponent,
        SarlaftVariablesCondicionesComponent,
        SarlaftModalSimuladorComponent,
        FlujoVentaComiteCreditoComponent,
        TasasVariablesListadoComponent,
        TasasVariablesEditarComponent,
        TasasVariablesEditarTasaComponent,
        DetalleTasaCondicionComponent,
        AprobacionTasaComponent,
        VerDetalleTasasComponent,
        PoliticaMatrizComponent,
        PoliticaTalanqueraComponent,
        MetaVentaSegurosComponent,
        ModalidadesFactorCrezcamosComponent,
        SimuladorPantallaGeneralComponent,
        ProductoMontosTasasComponent,
        ProductoPlazosComponent,
        ProductoMontosComponent,
        ProductoMontosPlazosComponent,
        TopeInversionComponent,
        TopeInversionDetalleComponent,
        TopeInversionEditarComponent,
        VigenciasAplComponent,
        AdministrationDocumentsAddComponent,
        AdministrationDocumentsDetailComponent,
        AdministrationDocumentsComponent,
        ValidityRequestsAddComponent,
        ValidityRequestsComponent,
        ValidityEmployeesAddComponent,
        ValidityEmployeesComponent,
        SimuladorPantallaGeneralComponent,
        ProductoMontosTasasComponent,
        ProductoPlazosComponent,
        ProductoMontosComponent,
        ProductoMontosPlazosComponent,
        TopeInversionComponent,
        TopeInversionDetalleComponent,
        ProductoGarantiaIdoneaComponent,
        SegurosBienesComponent,
        ProductoPasarelaComponent,
        ProductoPasarelaTarifasComponent,
        ProductoPasarelaContratosComponent,
        ProductoAdjuntosComponent,
        AdmsbListadoComponent,
        AdmsbTitularComponent,
        AdmsbTarifasComponent,
        AdmsbEncabezadoComponent,
        AdmsbUnidadProductivaComponent,
        AdmsbTarifasTablaComponent,
        AdmsbAdjuntosTablaComponent,
        AdmsbContratosTablaComponent,
        AdmsbContactosTablaComponent,
        FlujoVentaRecaudoComponent,
        FlujoVentaContratoComponent,
    ],
    providers: [
        CanalService,
        AuditoriaControlService,
        CanalProductoService,
        CanalRolService,
        RolesService,
        SegmentosService,
        SegmentoActividadesService,
        SegmentoProductosService,
        ActividadEconomicaService,
        ProductoService,
        NivelesService,
        NivelRangoService,
        DivisionPoliticaService,
        TipoTerceroClasificacionService,
        ConstanteService,
        BancoPreguntasService,
        RespuestaService,
        DineroPipe,
        ZonaService,
        ZonaBarrioService,
        EstructuraFisicaService,
        CuestionarioService,
        TerceroTipoTerceroService,
        TerceroTipoClasificacionService,
        TerceroService,
        AliadoUsuarioService,
        LocalizacionesService,
        UsuariosService,
        AgendasService,
        TerceroCargoService,
        TerceroZonaService,
        EstadoService,
        PerfilRiesgoService,
        PerfilRiesgoVariacionCicloService,
        PerfilRiesgoVariacionMontoService,
        AdjuntoService,
        CuestionarioPreguntaService,
        CuestionarioPreguntaRespuestaService,
        ProductoDestinoService,
        ProductoMontoService,
        ProductoDestinoMontoService,
        ProductoRenovacionService,
        ProductoFrecuenciaService,
        ProductoReferenciaService,
        ProductoGarantiaService,
        ProductoHistorialService,
        ProductoEstadoService,
        FuncionalidadesService,
        ProductoEstadoRelacionService,
        ProductoEstadoRelacionRolService,
        ProductoActividadService,
        ProductoActividadCampoService,
        ConceptoFacturacionService,
        ControlService,
        PalabraClaveService,
        PalabraClaveActividadEconomicaService,
        SincronizacionService,
        ProductoMontoAliadoService,
        PoliticasCreditoService,
        PoliticasCreditoOficinaService,
        PoliticaCreditoSegmentoService,
        ProductoControlService,
        ProductoCuestionarioService,
        ProductoEstadoRelacionCausalService,
        EstadoRolService,
        TipoCausalCausalSolicitudService,
        TipoOcupacionConfiguracionService,
        SegmentoIngresoService,
        SegmentoNivelEndeudamientoService,
        SegmentoActivoService,
        SegmentoEmpleadoService,
        SegmentoSectorService,
        SegmentoTipoContratoService,
        ProductoAutorizacionService,
        PlantillaService,
        RequisitosService,
        RequisitosRespaldosService,
        CentralRiesgoIntegracionService,
        CentralRiesgoIntegracionXDiaService,
        ProductoCuestionarioVoluntadPagoService,
        CuentaContableService,
        CuentaContableControlService,
        SeguroService,
        SeguroPlanService,
        ProductoSeguroAnalizamosService,
        TipoRespaldoService,
        TipoRespaldoCategoriaService,
        TipoRespaldoSubcategoriaService,
        TipoRespaldoSubcategoriaDetalleService,
        EstructuraFisicaPecuariaService,
        EstructuraFisicaAgricolaService,
        EstructuraAgricolaService,
        EstructuraPecuariaService,
        MenuVisitaService,
        MenuVisitaVinculacionService,
        MenuVisitaVinculacionOcupacionService,
        ProcesoProductivoService,
        ProcesoVariableIncidenciaService,
        PlagaService,
        PlagaProductoAgricolaService,
        ControlPlagaService,
        ProductoAgricolaService,
        FormaDesembolsoService,
        ProductoFormaDesembolsoService,
        ModalidadService,
        AlertaService,
        AlertaPerfilRiesgoService,
        AlertaEstructuraFisicaService,
        AlertaTipoVinculacionService,
        AlertaDetalleService,
        AlertaAprobacionService,
        AlertaDescarteService,
        VinculacionEstadoFinancieroService,
        ProductoFormaDesembolsoService,
        ModalidadService,
        ModalidadAutorizacionService,
        AgrupacionService,
        ProductoRestriccionOficinaService,
        ProductoRestriccionBarrioService,
        ModalidadTasaService,
        ModalidadCalificacionService,
        ProductoDesembolsoService,
        HomologacionEstadoService,
        ProductoEstadoRelacionNotificacionService,
        NotificacionesService,
        FaseService,
        FaseEstadoService,
        FaseEstadoRolService,
        ProductoConvenioFormaDesembolsoService,
        NivelTasaService,
        ConvenioService,
        HomologacionEstadoService,
        GrupoZonaService,
        GrupoService,
        CampaniaService,
        ExcepcionGmfService,
        TerceroRiesgoService,
        ExcepcionGMFDestinoService,
        EstadoBotonService,
        CampaniaService,
        CampaniaDctoCicloService,
        CampaniaDctoMontoservice,
        CampaniaDescuentoDestinoService,
        CampaniaDescuentoMoraService,
        NivelDescuentoService,
        CampaniaDctoMontoservice,
        ExcepcionGMFFormaDesembolsoService,
        ExcepcionGMFTipoCreditoService,
        SegmentoTipoVinculacionService,
        AlertaExcepcionService,
        ZonaLiberacionService,
        ProductoConfirmacionVinculacionService,
        PerfilRiesgoEstadoService,
        SistemaService,
        ProductoVinculacionMinimoService,
        ProductoVinculacionMinimoReferenciaService,
        PerfilRiesgoEstadoService,
        ConfiguracionUrlExternaService,
        SistemaService,
        SolicitudBloqueoSarlaftService,
        SolicitudService,
        SolicitudUcDesbloqueoService,
        SolicitudUnidadCreditoService,
        ProductoAlertaService,
        ProductoAlertaGrupoService,
        ProductoAlertaGrupoCondicionService,
        DescripcionErrorIntegracionService,
        AlfrescoService,
        ProductoReglaNegocioService,
        SolicitudUcBloqueoService,
        IntegracionValidatorService,
        ClausuladoService,
        PerfilRiesgoEstadoAutomaticoService,
        SolicitudUnidadCreditoTerceroRiesgoService,
        AliadoSucursalService,
        AliadoService,
        AliadoSucursalCupoService,
        AliadoUsuarioMovimientoService,
        ComunicationComponentsService,
        FlujoVentaPasoService,
        FlujoVentaPasoVinculacionService,
        FlujoVentaPasoControlService,
        FlujoVentaPasoAdjuntoService,
        FlujoVentaPasoComplementarioControlService,
        PaqueteSegurosService,
        PaqueteSegurosSegurosService,
        PaqueteSegurosSegurosPlanesService,
        ProductoHojaEvaluacionService,
        MatrizIdentidadService,
        ProductosRespaldosService,
        FlujoVentaPasoAutorizacionService,
        FlujoVentaPasoReintentoFuncionalidadControlService,
        FlujoVentaPasoReintentoService,
        SegmentoAdjuntoService,
        EstadoCausalService,
        FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitudService,
        FlujoVentaPasoReintentoCausalSolicitudService,
        SegmentoAdjuntoService,
        GarantiaService,
        GarantiaIdoneasService,
        ListaService,
        GarantiaIdoneasDestinosService,
        GarantiaIdoneasMunicipioService,
        GarantiaIdoneasActividadesService,
        GarantiaIdoneasProductoService,
        GarantiaIdoneasPeriodoGraciaService,
        GarantiaIdoneasPeriodoGraciaConceptosFacturacionService,
        TipoProductoresService,
        GarantiaIdoneasTipoProductoService,
        RequisitoGarantiaCantidadService,
        RequisitoGarantiaCantidadTipoVinculacionService,
        RequisitoGarantiaModalidadService,
        RequisitoGarantiaTipoRespaldoService,
        ConfiguracionesCanalesService,
        ProductosFlujoVentaPasosService,
        ProductosCategoriasService,
        RequisitosRespaldosTipoVincuracionService,
        RequisitosRespaldosProductosService,
        RequisitosRespaldosActividadesService,
        ProductosFlujoVentaPasosService,
        ProductoSeguroTipoDireccionService,
        ProductoSeguroTipoConstruccionService,
        ProductoSeguroClaseViviendaService,
        ConfiguracionCanalFlujoVentaPasoService,
        ConfiguracionCanalFlujoVentaPasoControlProductoService,
        RolFuncionalitiesServices,
        EstadoAdjuntoService,
        ProductoSubdestinoMontoAliadoService,
        ProductoSubdestinoService,
        ProductoSubdestinoMontoService,
        EstadoAdjuntoService,
        ProductoFrecuenciaCuotaService,
        PlantillaParametroService,
        PoliticasPlanteamientosPoliticasService,
        PoliticaService,
        ProductoPoliticaAlertaService,
        ConfiguracionCanalFlujoVentaPasoPoliticaProductoService,
        FlujoVentaPasoRestriccionPerfilVinculacionService,
        ProductosPeriodosGraciasService,
        ReglasNegocioVinculacionService,
        ReglasNegocioPlazoService,
        ProductosEstadosRelacionesTiposPreaprobadosService,
        PerfilesRiesgosScoreService,
        PlanCargoConceptoFacturacionService,
        PlanCargoService,
        ProductoPlanCargoService,
        DialogService,
        PagaduriaService,
        UsuarioComisionFreelanceService,
        PagaduriasCondicionesService,
        PagaduriasCondicionesHistoricosService,
        UsuariosProcesosService,
        UsuarioComisionFreelanceTarifaService,
        ProductoReferenciasParentescosService,
        SeguroCoberturaService,
        ServidorAlfrescoService,
        OcupacionesService,
        SarlaftCondicionesService,
        UsuarioTiposCreditosService,
        MetaVentaSegurosService
    ],
    exports: [
        FlujoVentaValidacionIdentidadComponent,
        CuestionariosListadoComponent
    ],
  // entryComponents: [ PagaduriaCondicionesEditarComponent, SarlaftModalSimuladorComponent, DetalleTasaCondicionComponent, AprobacionTasaComponent, SimuladorPantallaGeneralComponent ]
})

export class AplModule {
}
